import script from "./ExteraMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ExteraMenu.vue?vue&type=script&setup=true&lang=js"

import "./ExteraMenu.vue?vue&type=style&index=0&id=09bdd229&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09bdd229"]])

export default __exports__